<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title"></h4>
    </div>
    <div v-if="selectedBetgame" class="card-content">
      <form>

        <div class="row">
          <div class="col-md-3">
            <fg-input type="color"
                      label="Hauptfarbe"
                      v-model="selectedBetgame.primary_color">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <fg-input type="color"
                      label="Button-Farbe"
                      v-model="selectedBetgame.button_color">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <fg-input type="color"
                      label="Link-Farbe"
                      v-model="selectedBetgame.link_color">
            </fg-input>
          </div>
        </div>

        <div class="row" style="margin-top: 20px;">
          <div class="col-md-3">
            <h4>Icon</h4>
          </div>
        </div>
        <div class="row" style="padding: 0px 0px">
          <div class="col-md-12">
            <label>Das Icon im Format .jpg, oder .png sollte quadratisch und maximal 300 Pixel hoch/breit sein.</label>
          </div>
        </div>

        <div class="row" style="margin-top: 40px">
          <div class="col-md-6" style="text-align: left; background-color: white">
            <div v-if="this.selectedBetgame.icon" style="display: block">
              <img style="max-width: 200px; border: solid black 1px" :src="this.buildIconPath(this.selectedBetgame.icon, 300)">
            </div>
            <div style="background-color: #FFFFFF; margin-top: 10px;">
              <input id="imageFileInput" type="file" multiple :name="uploadFieldName" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                     accept="image/*" class="input-file" style="display: none" hidden>
              <button v-if="!this.selectedBetgame.icon" class="btn btn-info btn-fill btn-wd" @click.prevent="uploadButtonClicked">Icon hochladen</button>
              <button v-else class="btn btn-info btn-fill btn-wd" @click.prevent="uploadButtonClicked">Icon ändern</button>
            </div>
            <div v-if="this.selectedBetgame.icon" style="background-color: #FFFFFF; margin-top: 10px;">
              <button class="btn btn-info btn-fill btn-wd" @click.prevent="deleteButtonClicked">Icon löschen</button>
            </div>
          </div>
        </div>

        <div class="text-right" style="margin-top: 30px; margin-bottom: 30px;">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="updateBetgame">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        selectedBetgame: {},
        uploadFieldName: 'icon'
      }
    },
    created () {
      if (!this.$store.state.betgameData) {
        this.$store.dispatch('fetchBetgame', this.$store.state.betgame)
      }
    },
    mounted () {
      this.selectedBetgame = this.$store.state.betgameData
    },
    methods: {
      save (file) {
        this.$store.dispatch('uploadBetgameIcon', file)
          .then(() => {
          })
          .catch(err => {
            this.$log.debug(err)
          })
      },
      filesChange (fieldName, fileList) {
        if (!fileList.length) return
        let file = fileList[0]
        let fileSizeinMB = file.size / 1024 / 1024
        if (fileSizeinMB < 10) {
          this.save(file)
        }
      },
      uploadButtonClicked () {
        document.getElementById('imageFileInput').click()
      },
      buildIconPath (icon, width) {
        return window.sessionStorage.getItem('bgbackend_apiUrl') + '/icons/' + width + '/' + icon
      },
      updateBetgame () {
        // alert('' + JSON.stringify(this.selectedBetgame))
        this.$store.dispatch('patchBetgame', {
          primary_color: this.selectedBetgame.primary_color,
          link_color: this.selectedBetgame.link_color,
          button_color: this.selectedBetgame.button_color
        })
          .then(() => {
            if (this.selectedBetgame) {
            }
            alert('Tippspiel-Daten wurden aktualisiert')
          })
          .catch(function (error) {
            this.$log.debug(error)
          })
          .finally(function () {
          })
      },
      deleteButtonClicked () {
        this.$store.dispatch('patchBetgame', {
          icon: null
        })
          .then(() => {
            if (this.selectedBetgame) {
              this.selectedBetgame.icon = null
            }
            alert('Tippspiel-Daten wurden aktualisiert')
          })
          .catch(function (error) {
            this.$log.debug(error)
          })
          .finally(function () {
          })
      }
    },
    computed: {
      betgameId () {
        return '' + this.selectedBetgame.id
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGEditDesignForm.vue